import {Component} from '@angular/core'
import version from '../assets/package.json'
import {RouterOutlet} from '@angular/router'
import {HeaderComponent} from './common/header/header.component'
import {FooterComponent} from '@sparbanken-syd/sparbanken-syd-theme'

@Component({
  selector: 'spb-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, HeaderComponent, FooterComponent]
})
export class AppComponent {
  public version = version.version
  public copyrightYears = `2023-${new Date().getFullYear()}`
}
